/* BIZARRA — Dawn 16.1.0 color-filtered product gallery.
   Keeps Shopify's native variant and cart behavior. Uses filename matching only when confident. */
(() => {
  'use strict';
  const colorOption = /^(color|colour|cor|cores|colorway)$/i;
  const slug = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const optionName = (el) => {
    const name = el.getAttribute('name') || '';
    const bracket = name.match(/^options\[(.+)\]$/i);
    if (bracket) return bracket[1].trim();
    if (colorOption.test(name.trim())) return name.trim();
    const legend = el.closest('fieldset')?.querySelector('legend');
    return (legend?.textContent || '').replace(/:.*$/, '').trim();
  };
  const selectedColor = (root) => {
    for (const el of root.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select, select[name^="options["]')) {
      if (el.type === 'radio' && !el.checked) continue;
      if (colorOption.test(optionName(el))) return el.value;
    }
    return null;
  };
  const mediaItems = (gallery) => Array.from(gallery.querySelectorAll('.product__media-list > li[data-media-id]'));
  const filePath = (item) => {
    const img = item.querySelector('img');
    const src = img?.currentSrc || img?.src || img?.getAttribute('src') || '';
    try { return decodeURIComponent(new URL(src, location.origin).pathname).toLowerCase(); }
    catch (_) { return src.toLowerCase(); }
  };
  const matchesColor = (item, colorSlug) => {
    if (!colorSlug) return false;
    return new RegExp('(?:^|[-_])' + colorSlug + '(?=[-_.]|$)', 'i').test(filePath(item));
  };
  const hide = (el, yes) => {
    if (!el) return;
    el.hidden = yes;
    el.toggleAttribute('data-bizarra-color-hidden', yes);
    if (yes) el.setAttribute('aria-hidden', 'true');
    else el.removeAttribute('aria-hidden');
  };
  function decorateColorChoices(root, items) {
    const controls = Array.from(root.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select, select[name^="options["]'));
    controls.forEach((control) => {
      if (!colorOption.test(optionName(control))) return;
      const values = control.tagName === 'SELECT'
        ? Array.from(control.options).map(o => ({ value: o.value, el: o }))
        : [{ value: control.value, el: control }];
      values.forEach(({value, el}) => {
const colorItems = items.filter(item => matchesColor(item, slug(value)));
const match = colorItems.find(item => /(?:^|[-_])front(?=[-_.]|$)/i.test(filePath(item))) || colorItems[0];
        const image = match?.querySelector('img');
        const src = image?.currentSrc || image?.src || image?.getAttribute('src');
        const label = el.tagName === 'OPTION' || !el.id ? null : root.querySelector('label[for="' + CSS.escape(el.id) + '"]');
        if (!src || !label) return;
        label.dataset.bizarraPhotoSwatch = 'true';
        label.style.setProperty('--bizarra-photo-swatch', 'url("' + src.replace(/"/g, '%22') + '")');
        label.setAttribute('title', value);
      });
    });
  }
  function apply(root) {
    if (!root?.isConnected) return;
    const gallery = root.querySelector('media-gallery');
    const color = selectedColor(root);
    if (!gallery || !color) return;
    const items = mediaItems(gallery);
    const colorSlug = slug(color);
    const matches = items.filter(item => matchesColor(item, colorSlug));
    if (!matches.length) {
      items.forEach(item => hide(item, false));
      gallery.querySelectorAll('.thumbnail-list [data-target]').forEach(item => hide(item, false));
      return;
    }
    items.forEach(item => hide(item, !matchesColor(item, colorSlug)));
    const ids = new Set(matches.map(item => item.dataset.mediaId));
    gallery.querySelectorAll('.thumbnail-list [data-target]').forEach(thumb => hide(thumb, !ids.has(thumb.getAttribute('data-target'))));
    const active = items.find(item => item.classList.contains('is-active') && !item.hidden);
    if (!active) {
const front = matches.find(item => /(?:^|[-_])front(?=[-_.]|$)/i.test(filePath(item)));
const target = (front || matches[0]).dataset.mediaId;
      const thumb = gallery.querySelector('.thumbnail-list [data-target="' + CSS.escape(target) + '"] button.thumbnail');
      if (thumb) thumb.click();
      else gallery.querySelector('media-gallery')?.setActiveMedia?.(target, true);
    }
    decorateColorChoices(root, items);
  }
  function boot() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(root => {
      let queued = false;
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; apply(root); });
      };
      root.addEventListener('change', event => { if (event.target?.matches?.('input, select')) schedule(); });
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class', 'checked'] });
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();